import { faEye, faEyeLowVision } from "@elynx/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Tooltip } from "@mui/material";

export type NavigationViewListToolbarProps = {
    viewAll: boolean;
    railMode?: boolean;
    onToggleViewAll: () => void;
    // onOpenSettings: () => void;
};

export default function NavigationViewListToolbar({
    viewAll,
    railMode,
    onToggleViewAll,
    // onOpenSettings
}: NavigationViewListToolbarProps) {
    return (
        <List
            disablePadding
            sx={{
                width: 1
            }}
        >
            {/* <ListItem
                disablePadding
            >
                <ListItemButton
                    onClick={
                        () => onOpenSettings()
                    }
                >
                    <ListItemIcon>
                        <Tooltip arrow placement="right" title={railMode
                            ? "Menu Settings"
                            : undefined
                        }>
                            <Box>
                                <FontAwesomeIcon icon={faGear} size="lg" />
                            </Box>
                        </Tooltip>
                    </ListItemIcon>
                    <ListItemText primary="Menu Settings" />
                </ListItemButton>
            </ListItem> */}

            <ListItem
                disablePadding
            >
                <ListItemButton
                    onClick={
                        () => onToggleViewAll()
                    }
                >
                    <ListItemIcon>
                        <Tooltip arrow placement="right" title={railMode
                            ? viewAll
                                ? "Viewing Full Menu"
                                : "Viewing My Menu"
                            : undefined
                        }>
                            <Box>
                                {viewAll
                                    ? <FontAwesomeIcon icon={faEye} size="lg" />
                                    : <FontAwesomeIcon icon={faEyeLowVision} size="lg" />
                                }
                            </Box>
                        </Tooltip>
                    </ListItemIcon>
                    <ListItemText primary={
                        viewAll
                            ? "Viewing Full Menu"
                            : "Viewing My Menu"
                    } />
                </ListItemButton>
            </ListItem>
        </List>
    );
}
